import classNames from "classnames";
import React, { Component } from "react";
import "../../../../styles/main.scss";

interface KuikaSmallTextProps extends React.HTMLAttributes<HTMLSpanElement> {
  children: React.ReactNode;
}

class KuikaSmallText extends Component<KuikaSmallTextProps> {
  render() {
    const { children, className, ...props } = this.props;

    return (
      <span className={classNames("kuika-typography-small", className)} {...props}>
        {children}
      </span>
    );
  }
}

export default KuikaSmallText;
